import { validationMixin } from "vuelidate";
const {
  required,
  minLength,
  or,
  alphaNum,
  email,
  numeric,
  helpers
} = require("vuelidate/lib/validators");

export const AppTabClick = {
  methods: {
    tabClick(e) {
      this.tabList.forEach(item => {
        item.active = false;
        if (e.target.id == item._id) {
          item.active = true;
          if (this.hasProgress) {
            this.$emit("updateProgress", {
              total: this.tabList.length,
              current: item._id
            });
          }
        }
      });
    }
  }
};

export const AppIsPastDate = {
  methods: {
    isPastDate(date) {
      let now = new Date();
      let defaultDate = now - 1000 * 60 * 60 * 24 * 1;
      defaultDate = new Date(defaultDate);
      return date < defaultDate;
    }
  }
};

export const AppMembersWatch = {
  watch: {
    toAddMembers(value) {
      value.map(item => {
        item.actionIcon = "plus";
      });
    },
    addedMembers(value) {
      value.map(item => {
        item.actionIcon = "minus";
      });
    }
  }
};

export const validator = {
  mixins: [validationMixin]
};
